/*
  nazzi-search.js
  Ricerca in overlay: apertura e chiusura del pannello, suggerimenti
  live dalla Predictive Search API di Shopify (endpoint suggest.json)
  renderizzati dal tema. Vanilla JS, nessuna libreria.
*/
(function () {
  var root = document.querySelector('[data-nazzi-search]');
  if (!root) return;

  var input = root.querySelector('.nazzi-search__input');
  var body = root.querySelector('.nazzi-search__body');
  var defaultView = root.querySelector('.nazzi-search__default');
  var resultsView = root.querySelector('.nazzi-search__results');
  var overlay = document.querySelector('.nazzi-search-overlay');
  var searchUrl = root.dataset.searchUrl || '/search';
  /* routes.predictive_search_url è /search/suggest: la variante JSON
     vuole il suffisso .json, altrimenti risponde HTML */
  var suggestUrl = (root.dataset.suggestUrl || '/search/suggest').replace(/\.json$/, '') + '.json';
  var debounceTimer = null;
  var lastQuery = '';
  var controller = null;

  function esc(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }

  function highlight(title, query) {
    var safe = esc(title);
    if (!query) return safe;
    try {
      var pattern = new RegExp('(' + query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'i');
      return safe.replace(pattern, '<mark>$1</mark>');
    } catch (e) {
      return safe;
    }
  }

  function setOpen(open) {
    document.body.classList.toggle('nazzi-search-open', open);
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      // chiude l'eventuale menu mobile aperto: mai due pannelli insieme
      document.body.classList.remove('nazzi-menu-open');
      var header = document.querySelector('.nazzi-header');
      if (header) header.classList.remove('nazzi-header--open');
      var toggle = document.querySelector('.nazzi-header__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () { input.focus(); }, 120);
    } else if (input) {
      input.blur();
    }
  }

  document.querySelectorAll('[data-nazzi-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      setOpen(!document.body.classList.contains('nazzi-search-open'));
    });
  });

  root.querySelectorAll('[data-nazzi-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { setOpen(false); });
  });

  if (overlay) {
    overlay.addEventListener('click', function () { setOpen(false); });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });

  function showDefault() {
    defaultView.hidden = false;
    resultsView.hidden = true;
    resultsView.innerHTML = '';
  }

  function showLoading() {
    defaultView.hidden = true;
    resultsView.hidden = false;
    resultsView.innerHTML = '<div class="nazzi-search__state"><span class="nazzi-search__spinner" aria-hidden="true"></span> Sto cercando...</div>';
  }

  function productItem(product, query) {
    var image = product.featured_image && product.featured_image.url
      ? '<img src="' + esc(product.featured_image.url) + '&width=96" alt="" width="44" height="44" loading="lazy">'
      : '';
    var price = product.price ? '<span class="nazzi-search__item-price">' + esc(product.price) + ' €</span>' : '';
    return (
      '<a class="nazzi-search__item" href="' + esc(product.url) + '">' + image +
      '<span><span class="nazzi-search__item-title">' + highlight(product.title, query) + '</span>' +
      '<span class="nazzi-search__item-meta">Prodotto</span></span>' + price + '</a>'
    );
  }

  function pageItem(item, query, kind) {
    return (
      '<a class="nazzi-search__item" href="' + esc(item.url) + '">' +
      '<span><span class="nazzi-search__item-title">' + highlight(item.title, query) + '</span>' +
      '<span class="nazzi-search__item-meta">' + kind + '</span></span></a>'
    );
  }

  function render(data, query) {
    var res = data.resources && data.resources.results ? data.resources.results : {};
    var products = res.products || [];
    var pages = res.pages || [];
    var articles = res.articles || [];
    var queries = res.queries || [];
    var html = '';

    if (queries.length) {
      html += '<div class="nazzi-search__queries">';
      queries.slice(0, 4).forEach(function (q) {
        html += '<a class="nazzi-search__chip" href="' + esc(q.url) + '">' + highlight(q.text, query) + '</a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<h4 class="nazzi-search__group-title">Prodotti</h4><div class="nazzi-search__items">';
      products.forEach(function (p) { html += productItem(p, query); });
      html += '</div>';
    }

    if (pages.length || articles.length) {
      html += '<h4 class="nazzi-search__group-title" style="margin-top:1.6rem;">Pagine e articoli</h4><div class="nazzi-search__items">';
      pages.forEach(function (p) { html += pageItem(p, query, 'Pagina'); });
      articles.forEach(function (a) { html += pageItem(a, query, 'Dal blog'); });
      html += '</div>';
    }

    if (!html) {
      html =
        '<div class="nazzi-search__state nazzi-search__empty"><span><strong>Nessun risultato per "' + esc(query) + '"</strong>' +
        'Prova con un altro termine, oppure <a href="https://api.whatsapp.com/send?phone=393792161638&text=' +
        encodeURIComponent('Salve! Ho cercato "' + query + '" sul vostro sito ma non ho trovato quello che mi serve. Potete consigliarmi?') +
        '" target="_blank" rel="noopener">chiedi al farmacista su WhatsApp</a>.</span></div>';
    } else {
      html +=
        '<a class="nazzi-search__all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last">' +
        'Vedi tutti i risultati per "' + esc(query) + '"' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
    }

    resultsView.innerHTML = html;
  }

  function fetchSuggestions(query) {
    if (controller) controller.abort();
    controller = new AbortController();
    var params =
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product,page,article,query' +
      '&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,body,tag';
    fetch(suggestUrl + params, { signal: controller.signal })
      .then(function (r) {
        // Store con password vetrina: l'endpoint predittivo redirige a
        // /password e non è raggiungibile finché il negozio non è pubblico.
        if (r.redirected && /\/password/.test(r.url)) {
          var e = new Error('storefront-locked');
          e.locked = true;
          throw e;
        }
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (query === lastQuery) render(data, query);
      })
      .catch(function (err) {
        if (err.name === 'AbortError' || query !== lastQuery) return;
        if (err.locked) {
          resultsView.innerHTML =
            '<div class="nazzi-search__state">I suggerimenti live si attivano alla pubblicazione del sito. Intanto ' +
            '<a href="' + esc(searchUrl) + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last">vedi i risultati per "' + esc(query) + '"</a>.</div>';
        } else {
          resultsView.innerHTML =
            '<div class="nazzi-search__state">Ricerca non disponibile in questo momento. ' +
            '<a href="' + esc(searchUrl) + '?q=' + encodeURIComponent(query) + '">Vai alla pagina di ricerca</a>.</div>';
        }
      });
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    lastQuery = query;
    window.clearTimeout(debounceTimer);
    if (query.length < 2) {
      showDefault();
      return;
    }
    showLoading();
    debounceTimer = window.setTimeout(function () { fetchSuggestions(query); }, 250);
  });
})();
